module.exports = __webpack_public_path__ + "img/tripplanner-dark copy.c25b3d1f.svg";